import { environment } from 'config'

export function getMarketingSiteUrl(path: string) {
  return `https://${environment.isProduction ? '' : 'staging.'}archblock.com${path}`
}
